module.exports = __webpack_public_path__ + "static/media/share-desktop_disabled_light.1333e030.svg";